@let hasPrevious = store.hasPreviousSg();
@let hasNext = store.hasNextSg();
@let canSubmit = store.canSubmitSg();

<div
  footer
  class="atn-quiver-deployment-modal-footer"
>
  <atn-ds-button
    class="atn-quiver-deployment-modal-footer__cancel-button"
    type="transparent"
    (click)="store.cancel()"
  >
    Cancel
  </atn-ds-button>

  @if (hasPrevious) {
    <atn-ds-button
      type="transparent"
      (click)="store.previous()"
    >
      Previous
    </atn-ds-button>
  }
  @if (hasNext) {
    <atn-ds-button (click)="store.next()"> Next </atn-ds-button>
  } @else {
    <atn-ds-button
      (click)="store.submit()"
      [disabled]="!canSubmit"
    >
      Submit
    </atn-ds-button>
  }
</div>
